import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import Label from 'oxyrion-ui/lib/Label/Label';
import PropTypes from 'prop-types';
import moment from 'moment';
import Loader from 'oxyrion-ui/lib/Loader';
import { connect, actions } from '../../../../Store';
import AlertPopup from '../../../../Components/AlertPopup';
import { __, formatPrice, getIdFromProps, formatDate } from '../../../../Utils';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';
import ErrorMessage from '../../../../Components/ErrorMessage';
import InvoicesRows from '../Rows';
import API2 from '../../../../API2';

const InputWrapper = styled.div`
  width: ${rem(350)};
`;

const Row = styled.div`
  margin-bottom: ${rem(15)};
  display: flex;
`;

const StyledLabel = styled(Label)`
  margin-right: ${rem(4)};
  font-size: 16px;
`;

const Value = styled.div`
  width: ${rem(300)};
  font-size: 14px;
`;

const Wrapper = styled.div`
  padding: ${rem(20)};
`;

const MainContainer = styled.div`
  padding: ${rem(16)};
`;

const DownloadLink = styled.div`
  font-size: ${rem(14)};
  color: #70af00;
  margin-top: ${rem(16)};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

class InvoiceDetail extends React.Component {
  state = {
    productLoading: true,
    invoiceData: {},
  };

  async componentDidMount() {
    const id = getIdFromProps(this.props);
    await this.fetchInvoice(id);

    actions.setActiveMenuItem('47');
  }

  async fetchInvoice(id) {
    try {
      const invoiceData = await API2.getB2BInvoiceAction(id);
      this.setState({
        productLoading: false,
        invoiceData,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async downloadFile(id) {
    try {
      this.setState({
        downloadLoading: true,
        error: false,
      });

      const result = await API2.getB2BInvoicePDFFileAction(id);

      this.setState({
        downloadId: result.url,
        downloadLoading: false,
      });
    } catch (e) {
      this.setState({
        downloadLoading: false,
        error: __('Nepodarlo sa vygenerovať PDF'),
      });
    }
  }

  async downloadXMLFile(id) {
    try {
      this.setState({
        xmlDownloadLoading: true,
        error: false,
      });

      // const result = await API2.getB2BInvoiceXMLFileAction(id, {
      //   type: 'pohoda',
      // });
      // nepouziva sa uz

      this.setState({
        // downloadId: result.url,
        downloadLoading: false,
      });
    } catch (e) {
      this.setState({
        xmlDownloadLoading: false,
        error: __('Nepodarlo sa vygenerovať XML'),
      });
    }
  }

  async downloadFileWithId(downloadId) {
    window.location.href = downloadId;

    this.setState({
      downloadId: undefined,
    });
  }

  render() {
    const {
      productLoading,
      invoiceData,
      downloadId,
      downloadLoading,
      error,
      xmlDownloadLoading,
    } = this.state;

    if (productLoading) {
      return (
        <LoaderWrapper>
          <Loader size="xl" color="#70af00" />
        </LoaderWrapper>
      );
    }

    return (
      <MainContainer>
        <AlertPopup
          alignUnderHeader
          display={downloadId}
          style
          onClose={() =>
            this.setState({
              downloadId: undefined,
            })
          }
          scrollContent
          question
          text={__(`Prajete si uložiť súbor`)}
          onSubmit={() => this.downloadFileWithId(downloadId)}
          onDismiss={() =>
            this.setState({
              downloadId: undefined,
            })
          }
        />
        <ErrorMessage display={error} text={error} />
        <Wrapper>
          <Row>
            <InputWrapper>
              <StyledLabel>{__('Číslo faktúry')}</StyledLabel>
              <Value>{invoiceData._id}</Value>
            </InputWrapper>

            <InputWrapper>
              <StyledLabel>{__('Dátum vytvorenia')}</StyledLabel>
              <Value>{formatDate(moment(invoiceData.created_date))}</Value>
            </InputWrapper>

            <InputWrapper>
              <StyledLabel>{__('Celková cena bez DPH')}</StyledLabel>
              <Value>{formatPrice(invoiceData.price)}</Value>
            </InputWrapper>

            <InputWrapper>
              <DownloadLink
                onClick={() => this.downloadXMLFile(getIdFromProps(this.props))}
              >
                {xmlDownloadLoading ? <Loader /> : __('Stiahnúť XML')}
              </DownloadLink>
            </InputWrapper>
          </Row>

          <Row>
            <InputWrapper>
              <StyledLabel>{__('Predajca')}</StyledLabel>
              <Value>{invoiceData.user_name}</Value>
            </InputWrapper>

            <InputWrapper>
              <StyledLabel>{__('Zákazník')}</StyledLabel>
              <Value>{invoiceData.customer_name}</Value>
            </InputWrapper>

            <InputWrapper>
              <StyledLabel>{__('Celková cena s DPH')}</StyledLabel>
              <Value>{formatPrice(invoiceData.price_vat)}</Value>
            </InputWrapper>

            <InputWrapper>
              <DownloadLink
                onClick={() => this.downloadFile(getIdFromProps(this.props))}
              >
                {downloadLoading ? <Loader /> : __('Stiahnúť PDF')}
              </DownloadLink>
            </InputWrapper>
          </Row>
        </Wrapper>
        <InvoicesRows
          id={getIdFromProps(this.props)}
          location={this.props.location}
        />
      </MainContainer>
    );
  }
}

InvoiceDetail.propTypes = {
  location: PropTypes.shape.isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(InvoiceDetail);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Invoices/Detail/index.jsx